import { render, staticRenderFns } from "./searchList.vue?vue&type=template&id=38f51052&scoped=true&"
import script from "./searchList.vue?vue&type=script&lang=js&"
export * from "./searchList.vue?vue&type=script&lang=js&"
import style0 from "./searchList.vue?vue&type=style&index=0&id=38f51052&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f51052",
  null
  
)

export default component.exports